(function () {
  'use strict';

  var STORAGE_KEY = 'kv_store_recommendation';
  var PREFERENCE_STAY = 'stay';
  var PREFERENCE_GO = 'go';

  var STORE_MAP = {
    US: 'https://us.cibleskin.com'
  };

  var MAIN_STORE_HOSTS = ['cibleskin.com', 'www.cibleskin.com'];

  function isMainStore() {
    var host = window.location.hostname.toLowerCase();
    return MAIN_STORE_HOSTS.indexOf(host) !== -1;
  }

  function getSavedPreference() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function savePreference(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore quota / privacy mode */
    }
  }

  function clearPreference() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    var config = window.kvStoreRecommendationConfig || {};
    return config.shopifyRoot || '/';
  }

  function getFallbackCountry() {
    var config = window.kvStoreRecommendationConfig || {};
    return config.fallbackCountry || '';
  }

  function fetchDetectedCountry() {
    var root = getShopifyRoot();
    var url = root + 'browsing_context_suggestions.json?country[enabled]=true';

    return fetch(url, {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Country detection failed');
        return response.json();
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        return country && country.handle ? String(country.handle).toUpperCase() : '';
      })
      .catch(function () {
        return getFallbackCountry();
      });
  }

  function getStoreUrl(countryCode) {
    return STORE_MAP[countryCode] || '';
  }

  function openPopup(rootEl) {
    rootEl.hidden = false;
    rootEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kv-store-recommendation-open');

    var goBtn = rootEl.querySelector('[data-kv-store-recommendation-go]');
    if (goBtn) goBtn.focus();
  }

  function closePopup(rootEl) {
    rootEl.setAttribute('aria-hidden', 'true');
    rootEl.hidden = true;
    document.body.classList.remove('kv-store-recommendation-open');
  }

  function init() {
    if (!isMainStore()) return;

    var rootEl = document.querySelector('[data-kv-store-recommendation]');
    if (!rootEl) return;

    if (getSavedPreference()) return;

    var goBtn = rootEl.querySelector('[data-kv-store-recommendation-go]');
    var stayBtn = rootEl.querySelector('[data-kv-store-recommendation-stay]');
    var overlay = rootEl.querySelector('[data-kv-store-recommendation-overlay]');
    var targetUrl = '';

    fetchDetectedCountry().then(function (countryCode) {
      countryCode = String(countryCode || '').toUpperCase();
      targetUrl = getStoreUrl(countryCode);

      if (!targetUrl) return;

      openPopup(rootEl);

      if (goBtn) {
        goBtn.addEventListener('click', function () {
          savePreference(PREFERENCE_GO + ':' + countryCode);
          window.location.href = targetUrl;
        });
      }

      if (stayBtn) {
        stayBtn.addEventListener('click', function () {
          savePreference(PREFERENCE_STAY);
          closePopup(rootEl);
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function () {
          savePreference(PREFERENCE_STAY);
          closePopup(rootEl);
        });
      }

      rootEl.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          savePreference(PREFERENCE_STAY);
          closePopup(rootEl);
        }
      });
    });
  }

  window.kvStoreRecommendation = {
    reset: clearPreference,
    storageKey: STORAGE_KEY
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
